module.exports = __webpack_public_path__ + "img/kid-item2.8d5a3c27.png";